import type { ButtonConfig } from '../declare'
import * as Pager from './pager'
import { $consts } from 'src/plugins'

/**
 * 竖树表单页面类型按钮
 * @param props 
 * @returns 
 */
const PagerButton = (props: { config: ButtonConfig }) => {
  const { BTN_TYPE } = props.config
  switch (BTN_TYPE) {
    // 自定义表单按钮
    case $consts['TABLE/BTN_TYPE_CUSTOM_PAGE']:
      return <Pager.FormPageBtn config={props.config} />
    // 编辑表单按钮
    case $consts['TABLE/BTN_TYPE_EDIT_PAGE']:
      return <Pager.EditPageBtn config={props.config} />
    // 列表表单按钮
    case $consts['TABLE/BTN_TYPE_LIST_PAGE']:
      return <Pager.ListPageBtn config={props.config} />
    // 组合表单按钮
    case $consts['TABLE/BTN_TYPE_MULTI_PAGE']:
      return <Pager.MultiPageBtn config={props.config} />
    default:
      return <div />
  }
}

export default PagerButton